import { DataSourcesEnum } from '../enums/DataSourcesEnum';
import { IHAChange } from '../interfaces/IHAChange';
import { IHAStatic } from '../interfaces/IHAStatic';
import { ILoadedDataSource } from '../interfaces/ILoadedDataSource';
import { IElectionDate } from '../interfaces/IElectionDate';
import { ElectionCount } from './ElectionCount';
import { ILCChange } from '../interfaces/ILCChange';
import { ILCStatic } from '../interfaces/ILCStatic';
import { LCElectionCount } from './LCElectionCount';
import { ILGEChange } from '../interfaces/ILGEChange';
import { LGE } from './LGE';
import { ILGEStatic } from '../interfaces/ILGEStatic';




export class DataStore {


  private loaded: ILoadedDataSource[] = [
 //   { dataSource: DataSourcesEnum.ElectionDates, isLoaded: false },
    { dataSource: DataSourcesEnum.HAStatic, isLoaded: false },
    { dataSource: DataSourcesEnum.HAChange, isLoaded: false },
    { dataSource: DataSourcesEnum.LCStatic, isLoaded: false },
    { dataSource: DataSourcesEnum.LCChange, isLoaded: false },
    { dataSource: DataSourcesEnum.LGEStatic, isLoaded: false },
    { dataSource: DataSourcesEnum.LGEChange, isLoaded: false }
  ];

  private lastDataSourceLoaded: DataSourcesEnum | null = null;


//  
  public haStatic: IHAStatic | null = null;
  public haChange: IHAChange | null = null;
  public lcStatic: ILCStatic | null = null;
  public lcChange: ILCChange | null = null;
 // public halcHistory: IHALCHistory[] = [];
  public electionCount: ElectionCount | null = null;
  public lcElectionCount: LCElectionCount | null = null;

  public lgeStatic: ILGEStatic | null = null;
  public lgeChange: ILGEChange | null = null;
  public lge: LGE | null = null;
  public nominationsClose: string | null = null;


  // private candidatesMap: Map<string, IHAStaticCandidate> = new Map<string, IHAStaticCandidate>();



  public dataSourceLoaded(dataSource: DataSourcesEnum): void {
    this.lastDataSourceLoaded = dataSource;
    const found = this.loaded.find(x => x.dataSource === dataSource);
    if (found) {
      found.isLoaded = true;
    }
  }

  public dataSourceTrigger(dataSources: DataSourcesEnum[]): boolean {
    if (dataSources.length === 0) {
      return false;
    }
    if (this.lastDataSourceLoaded !== null ) {    // && dataSources.includes(this.lastDataSourceLoaded)
      let result = true;
      dataSources.forEach(item => {
        const found = this.loaded.find(x => x.dataSource ===  item);
        result = result && (found ? found.isLoaded : false);
      });
      return result;
    }
    return false;
  }



  public CheckBuildCountView(): void {
    if (this.haStatic !== null && this.haChange !== null) {
   //   const history = this.halcHistory.find(x => x.electionType === this.haStatic?.electionType && x.electionDate === this.haStatic?.prevElectionDate)??null;
   //   if (history !== null) {
        this.electionCount = new ElectionCount(this.haStatic, this.haChange);
        // console.log('ElectionCount');
        // console.log(this.electionCount);
    //  }
    }
  }

  public CheckBuildLCCountView(): void {
    if (this.lcStatic !== null && this.lcChange !== null && this.haStatic !== null) {
      this.lcElectionCount = new LCElectionCount(this.lcStatic, this.lcChange, this.haStatic);
      // console.log('LCElectionCount');
      // console.log(this.lcElectionCount);
    }
  }


  public CheckBuildLGEView(): void {
    if (this.lgeStatic !== null) {
      this.lge = new LGE(this.lgeChange, this.lgeStatic, this.getNominationClose());
      // console.log('LGE');
      // console.log(this.lge);
    }
  }



  public addLCStatic(lcStatic: ILCStatic): void {
    this.lcStatic = lcStatic;
    this.CheckBuildLCCountView();
  }

  public addLCChange(lcChange: ILCChange): void {
    this.lcChange = lcChange;
    this.CheckBuildLCCountView();
  }

  public addHAStatic(haStatic: IHAStatic): void {
    this.haStatic = haStatic;
    this.CheckBuildCountView();
    this.CheckBuildLCCountView();
    // // load districts
    // this.districts = this.haStatic && this.haStatic.districts ? this.haStatic?.districts?.map(x => {
    //   return {
    //     uid: `districts/${x.districtName}`,
    //     districtName: x.districtName
    //   };
    // }) : [];

    // // map candidates
    // this.haStatic?.districts?.map(district => {
    //   district.candidates.map(candidate => {
    //     this.candidatesMap.set(candidate.uid, candidate);
    //   });
    // });



  // private setLookup(lookuptype: LookupTypeEnum, id: string, name: string): void {
  //   this.lookupNames.set(LookupTypeEnum[lookuptype] + '/' + id, name);
  // }


  // public getLookup(lookuptype: LookupTypeEnum, id: string): string {
  //   return this.lookupNames.get(LookupTypeEnum[lookuptype] + '/' + id);
  // }

  }

  public addHAChange(haChange: IHAChange): void {
    this.haChange = haChange;
    this.CheckBuildCountView();
  }

  // public addElectionDates(electionDates: IElectionDate[]): void {
  //   this.electionDates = electionDates;
  // }

  public addLGEStatic(lgeStatic: ILGEStatic, nominationsClose: string): void {
    this.lgeStatic = lgeStatic;
    this.nominationsClose = nominationsClose;
    this.CheckBuildLGEView();
  }

  public addLGEChange(lgeChange: ILGEChange): void {
    this.lgeChange = lgeChange;
    this.CheckBuildLGEView();
  }

  public getNominationClose(): Date | null {
    if (this.nominationsClose === null || this.nominationsClose === '') {
      return null;
    }
    return new Date(this.nominationsClose);
  }


}
